export function getReservationApprovalControlVisibility(_a) {
    var pendingApproval = _a.pendingApproval, hasApprovalPermission = _a.hasApprovalPermission, permissionLoading = _a.permissionLoading, showApprovalButtons = _a.showApprovalButtons;
    var showEditApprovalControl = !pendingApproval && hasApprovalPermission && !permissionLoading;
    var showActionButtons = (pendingApproval || showApprovalButtons) &&
        hasApprovalPermission &&
        !permissionLoading;
    return {
        showEditApprovalControl: showEditApprovalControl,
        showActionButtons: showActionButtons,
    };
}
